import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { HandleSummaryReportByInternshipLocation } from 'domain/usecases';

interface ISummaryReportByInternshipLocation {
  summaryReportByInternshipLocation: HandleSummaryReportByInternshipLocation.Result[];
}

interface IPayloadData
  extends PayloadAction<HandleSummaryReportByInternshipLocation.Result[]> {}

const initialState: ISummaryReportByInternshipLocation = {
  summaryReportByInternshipLocation: null,
};

export const SummaryReportByInternshipLocation = createSlice({
  name: 'summary-report-by-internship-location',
  initialState,
  reducers: {
    loadSummaryReportByInternshipLocation: (state, action: IPayloadData) => {
      state.summaryReportByInternshipLocation = action.payload;
    },
    clearSummaryReportByInternshipLocation: (state) => {
      state.summaryReportByInternshipLocation = null;
    },
  },
});

export const {
  loadSummaryReportByInternshipLocation,
  clearSummaryReportByInternshipLocation,
} = SummaryReportByInternshipLocation.actions;

export default SummaryReportByInternshipLocation.reducer;
